import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, RefreshCw, Send } from 'lucide-react';
import { Button } from '../ui/button';
import { BACKEND_URL } from './constants';
import { getToken } from '../../services/tokenService';

// Envoi du PDF officiel signé + export CSV au comptable (adresse saisie à chaque envoi)
export default function EnvoiComptable({ debut, fin }) {
  const [email, setEmail] = useState('');
  const [envoi, setEnvoi] = useState(false);

  const envoyer = async () => {
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) { toast.error("Saisissez l'adresse email du comptable"); return; }
    setEnvoi(true);
    try {
      const { data } = await axios.post(`${BACKEND_URL}/api/recus-ess/recap-contributions/envoyer`, { debut, fin, email: email.trim() },
        { headers: { Authorization: `Bearer ${getToken()}` }, timeout: 120000 });
      toast.success(data.message);
      setEmail('');
    } catch (err) { toast.error(err.response?.data?.detail || "Erreur lors de l'envoi"); }
    finally { setEnvoi(false); }
  };

  return (
    <div className="flex flex-wrap items-center gap-2 p-3 rounded-lg bg-slate-50 border" data-testid="recap-envoi-comptable">
      <Mail className="h-4 w-4 text-slate-500" />
      <span className="text-sm text-slate-700">Envoyer au comptable (PDF signé + CSV) :</span>
      <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="email du comptable"
        className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm flex-1 min-w-[220px]" data-testid="recap-envoi-email" />
      <Button onClick={envoyer} disabled={envoi} size="sm" className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="recap-envoi-btn">
        {envoi ? <RefreshCw className="h-4 w-4 mr-1 animate-spin" /> : <Send className="h-4 w-4 mr-1" />} Envoyer
      </Button>
    </div>
  );
}
